export class LectureServiceInterface {
}
